const testimonials = [
  {
    name: "Sgt. James R.",
    location: "Fort Benning, GA",
    rating: 5,
    text: "Got orders for Germany with two weeks notice. My passport was expired and I was panicking. Fast Passport Center had my emergency expedited passport ready in 5 days. They understood the military timeline and made it happen.",
    service: "Emergency Passport",
  },
  {
    name: "Michelle D.",
    location: "Columbus, GA",
    rating: 5,
    text: "We planned a family cruise to the Caribbean and realized my son's passport had expired two months ago. Fast Passport Center walked us through the child passport process, told us exactly which clerk to visit in Columbus, and had his new passport in hand with a week to spare.",
    service: "Child Passport",
  },
  {
    name: "David K.",
    location: "Phenix City, AL",
    rating: 5,
    text: "Business trip to Tokyo got moved up unexpectedly. I called on a Monday from my office in Phenix City, shipped from Columbus Tuesday, and had my expedited passport by Friday. Professional, fast, and they kept me updated every step.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ColumbusTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Columbus &amp; Fort Benning Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Columbus, Fort Benning, Phenix City, and the Chattahoochee Valley who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}